import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Partners from './components/Partners';
import About from './components/About';
import Products from './components/Products';
import WhyGRP from './components/WhyGRP';
import Gallery from './components/Gallery';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './styles/global.css';

const App: React.FC = () => (
  <div>
    <Navbar />
    <Hero />
    <Partners />
    <About />
    <Products />
    <WhyGRP />
    <Gallery />
    <Process />
    <Testimonials />
    <Contact />
    <Footer />
  </div>
);

export default App;
